<ll-titulo>Editar actividad #{{ actividadId }}</ll-titulo>
<actividad-edit [actividadId]="actividadId"></actividad-edit>
